import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "@/components/ProtectedRoute";
import AtriumShell from "@/components/atrium/AtriumShell";
import Login from "@/pages/Login";
import AtriumToday from "@/pages/atrium/AtriumToday";
import AtriumClientsList from "@/pages/atrium/AtriumClientsList";
import AtriumClientDetail from "@/pages/atrium/AtriumClientDetail";
import AtriumPipeline from "@/pages/atrium/AtriumPipeline";
import AtriumOps from "@/pages/atrium/AtriumOps";
import AtriumKnowledge from "@/pages/atrium/AtriumKnowledge";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<AtriumShell />}>
            <Route path="/" element={<AtriumToday />} />

            <Route path="/clients" element={<AtriumClientsList />} />
            <Route path="/clients/:slug" element={<AtriumClientDetail />} />
            {/* Legacy per-client sub-pages → fold into the detail view */}
            <Route path="/clients/:slug/*" element={<AtriumClientDetail />} />

            <Route path="/pipeline" element={<AtriumPipeline />} />
            {/* Bizdev was a sibling section in the old IA; Pipeline absorbs it */}
            <Route path="/bizdev/*" element={<Navigate to="/pipeline" replace />} />

            <Route path="/ops" element={<AtriumOps />} />
            <Route path="/ops/*" element={<AtriumOps />} />

            <Route path="/knowledge" element={<AtriumKnowledge />} />
            <Route path="/knowledge/*" element={<AtriumKnowledge />} />

            {/* Personal stub had no Atrium home; route home for now */}
            <Route path="/personal/*" element={<Navigate to="/" replace />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
